// Spaced-repetition weight updates shared by the medication drill and daily challenge.
// weight starts at 1. Correct → ×0.6 (min 0.25). Missed → ×1.9 (max 4).
export function applyMedResult(medication, classId, medId, correct) {
  const classProg = medication?.[classId] || { weights: {}, mastery: {} };
  const curW = classProg.weights?.[medId] ?? 1;
  const nextW = correct ? Math.max(0.25, curW * 0.6) : Math.min(4, curW * 1.9);
  const mastery = { ...(classProg.mastery || {}) };
  mastery[medId] = Math.max(0, (mastery[medId] || 0) + (correct ? 1 : -1));
  return {
    ...(medication || {}),
    [classId]: { weights: { ...(classProg.weights || {}), [medId]: nextW }, mastery },
  };
}

export function missedMedIds(medication) {
  const ids = new Set();
  Object.values(medication || {}).forEach((c) => {
    Object.entries(c?.weights || {}).forEach(([id, w]) => { if (w > 1) ids.add(id); });
  });
  return ids;
}

export function updateMissedRhythms(stats, missed = [], correct = []) {
  const set = new Set(stats?.missed_rhythms || []);
  correct.forEach((id) => set.delete(id));
  missed.forEach((id) => set.add(id));
  return [...set];
}
